module.exports = __webpack_public_path__ + "static/media/pix.2d419480.svg";